import { createStore } from '@direct-frontend/modules-store';

export const compareWarehousesOzonFbsStore = createStore('features/CompareWarehousesOzonFbsModal');
